import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const SaveIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentcolor">
            {/* eslint-disable-next-line max-len */}
            <path d="M2.91675 12.9165V12.0832H8.75008V12.9165H2.91675ZM2.91675 9.58317V8.74984H12.0834V9.58317H2.91675ZM2.91675 6.24984V5.4165H12.0834V6.24984H2.91675ZM13.6251 15.2563L11.2436 12.8748L11.8334 12.285L13.6251 14.0671L17.1667 10.5255L17.7565 11.1248L13.6251 15.2563Z" fill="currentcolor"/>
        </svg>
    </IconWrapper>
));
